<template>
  <section>
<!--    <h2 class="h2Title">{{board.boardName}}</h2>-->
    <article class="fieldMb">
      <form class="fieldWrap">
        <div class="fieldBx">
          <ul>
            <li class="formList">
              <dl>
                <dd>
                  <v-select v-model="param.searchCategory" :items="categoryItems" item-text="categoryName"
                            item-value="categoryId" label="카테고리"
                            dense
                            clearable
                            flat
                            outlined
                            v-on:change="search"
                  />
                </dd>
              </dl>

              <dl>
                <dd>
                  <v-col sm="6">
                    <v-text-field label="제목 / 내용 / 작성자 검색"
                                  v-model="param.searchKeyword" v-on:keyup.enter="search"
                                  dense clearable flat outlined/>
                  </v-col>
                </dd>
              </dl>

            </li>
          </ul>
<!--          <div class="searchBtn">-->
<!--            <v-btn color="#424964" @click="search()" depressed dark>검색</v-btn>-->
<!--          </div>-->
        </div>
      </form>
    </article>

    <article class="tableWrap">
      <div class="tableBx">
        <v-row class="fill-height">
          <v-col>
            <v-sheet height="64">
              <v-toolbar
                  flat
              >
                <v-btn
                    outlined
                    class="mr-4"
                    color="grey darken-2"
                    @click="setToday"
                >
                  Today
                </v-btn>
                <v-btn
                    fab
                    text
                    small
                    color="grey darken-2"
                    @click="prev"
                >
                  <v-icon small>
                    mdi-chevron-left
                  </v-icon>
                </v-btn>
                <v-btn
                    fab
                    text
                    small
                    color="grey darken-2"
                    @click="next"
                >
                  <v-icon small>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
                <v-toolbar-title v-if="$refs.calendar">
                  {{ $refs.calendar.title }}
                </v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn class="vBtn vIconResize mgr" @click="calOptions.type = 'month'" color="primary" dark>
                  <v-icon left>mdi mdi-calendar-month</v-icon>
                  월
                </v-btn>
                <v-btn class="vBtn vIconResize mgr" @click="calOptions.type = 'week'" color="primary" dark>
                  <v-icon left>mdi mdi-calendar-week</v-icon>
                  주
                </v-btn>
                <v-btn class="vBtn vIconResize mgr" @click="calOptions.type = 'day'" color="primary" dark>
                  <v-icon left>mdi mdi-calendar-today</v-icon>
                  일
                </v-btn>
                <v-btn class="vBtn vIconResize mgr" @click="calOptions.type = '4day'" color="primary" dark>
                  <v-icon left>mdi mdi-calendar-minus</v-icon>
                  4일
                </v-btn>


                <v-btn class="vBtn vIconResize mgr" @click="$router.push({path: 'article/form'})" color="#666" dark>
                  <v-icon left>mdi mdi-playlist-plus</v-icon>
                  등록
                </v-btn>
                <v-btn class="vBtn vIconResize mgr" @click="showList" color="success" dark>
                  <v-icon left>mdi mdi-playlist-plus</v-icon>
                  목록 보기
                </v-btn>
              </v-toolbar>
            </v-sheet>
            <v-sheet height="600">
              <v-calendar
                  ref="calendar"
                  v-model="calOptions.focus"
                  color="primary"
                  :events="schedules"
                  :event-color="getEventColor"
                  :event-more="calOptions.more"
                  :type="calOptions.type"
                  interval-count="0"
                  interval-height="0"
                  @click:event="showEvent"
                  @click:more="viewDay"
                  @click:date="viewDay"
                  @change="search"
              >
<!--                <template v-slot:day="{ past, date, present }">-->
<!--                  <template-->
<!--                      v-if="present"-->
<!--                      class="text-center"-->
<!--                  >-->
<!--                    {{ present }}-->
<!--                    {{ past }}-->
<!--                    {{ date }}-->
<!--                  </template>-->
<!--                </template>-->

              </v-calendar>
              <v-menu
                  v-model="selectedOpen"
                  :close-on-content-click="false"
                  :activator="selectedElement"
                  offset-x
              >
                <v-card
                    color="grey lighten-4"
                    min-width="350px"
                    flat
                >
                  <v-toolbar
                      :color="selectedEvent.color"
                      dark
                  >
                    <v-btn icon>
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon>
                      <v-icon>mdi-heart</v-icon>
                    </v-btn>
                    <v-btn icon>
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <span v-html="selectedEvent.details"></span>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                        text
                        color="secondary"
                        @click="selectedOpen = false"
                    >
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </v-sheet>
          </v-col>
        </v-row>
      </div>
    </article>

  </section>
</template>

<script>
import boardApi from '@/api/BoardApi'
import articleApi from '@/api/ArticleApi'
import roleApi from '@/api/RoleApi'
import _ from "lodash";

export default {
  name: "Article",
  data: () => ({
    monthLists: [
      {value: 1, text: '1개월'}, {value: 3, text: '3개월'}, {value: 6, text: '6개월'},
      {value: 12, text: '1년'}, {value: 0, text: '전체'}],
    activeItem: null,
    selected: [],
    headers: [
      {text: '번호', value: 'no', align: 'left'},
      {text: '제목', value: 'title', align: 'left'},
      {text: '카테고리', value: 'boardCategory.categoryName'},
      {text: '작성자', value: 'writer', align: 'center'},
      {text: '작성일', value: 'createdAt'},
      {text: '조회수', value: 'hits'},
      {text: '삭제여부', value: 'deleted', align: 'left'},
      {
        text: '관리',
        value: 'actions',
        align: 'center',
        sortable: false
      }
    ],
    param: {
      searchDate:[],
      searchState: null,
      searchRole: null,
      searchKeyword: null,
      page: 1,
      start: {},
      end: {}
    },
    articles: [],
    schedules: [],
    totalItems: 0,
    dialogVisible: false,
    selectArticle: {},
    waitingSearch: false,
    board: {},
    options:{},
    calOptions:{
      focus: '',
      type: 'month',
      more: true
    },
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      '4day': '4 Days',
    },
    events: [],
    colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
    categoryItems: [],
  }),
  watch: {
    'param.searchKeyword': {
      handler(nv, ov) {
        if(nv === ov)
          return;
        this.options.page = 1;
        this.param.searchKeyword = nv;
        if (!this.waitingSearch) {
          setTimeout(() => {
            this.search(this.param);
            this.waitingSearch = false;
          }, 500); // 0.5 sec delay
        }
        this.waitingSearch = true;
      },
      deep: true
    }
  },
  methods: {
    onRowClick(item) {
      this.$router.push({path:`/board/${item.boardId}/article/view/${item.articleId}`});
    },
    getSearchDate(searchDate = []) {
      this.param.searchDate = searchDate;
      // watch param.searchDate
    },
    selectItem(months) {
      this.activeItem = months;
      // 0 is total
      if (this.activeItem !== 0) {
        this.param.searchDate = [this.$moment().subtract(months, "months").format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
      } else
        this.param.searchDate = [];
      // this.search(); // watch param.searchDate
    },
    search({ start, end }) {
      // console.log(this.options);
      // const {  page, itemsPerPage, size } = this.options;
      // console.log(start)
      // console.log(end)

      let params = {...this.param, ...{
            page: 1,
            size: -1,
            start,
            end,
            scheduleStartDate: this.$moment(start.date).add(-7, 'days').format('YYYY-MM-DD'),
            scheduleEndDate: this.$moment(end.date).add(7, 'days').format('YYYY-MM-DD')
      }};

      // console.log(params.scheduleStartDate +"-"+params.scheduleEndDate);
      this.articles = null;

      articleApi.dateRangeList(this.$route.params.id, params).then(data => {

        this.totalItems = data.totalElements;
        this.articles = data.content.map((a, i) => {
          // a.idx = this.totalItems - i - (( (params.page??1) - 1) * params.size);
          // return a;

          return Object.assign(a, {
            idx: this.totalItems - i - (( (params.page??1) - 1) * params.size),
            name: a.title,
            start: a.scheduleStartDt ? a.scheduleStartDt : null,
            end: a.scheduleEndDt ? a.scheduleEndDt : null,
            color: this.colors[this.rnd(0, this.colors.length - 1)],
            hasTime: false,
            timed: false,
          });
        });

        this.schedules = this.articles.filter(a => a.start !== null && a.end !== null);
        // console.log(this.schedules);
        this.$store.commit('setParams', params);

      });
    },
    showList() {
      // let params = this.$store.getters?.params??{};
      // params.boardType='TYPE_GENERAL';
      // this.$store.commit('setParams', params);
      // this.$router.push({path:`/board/${this.$route.params.id}/articles`});

      this.$emit('callback-change-list', 'TYPE_GENERAL');

    },
    setToday () {
      this.calOptions.focus = ''
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    getEventColor (event) {
      return event.color
    },
    rnd (a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
    viewDay ({ date }) {
      this.calOptions.focus = date
      this.calOptions.type = 'day'
    },
    showEvent ({ event }) {
      // console.log(event);
      this.$router.push({path:`/board/${event.boardId}/article/view/${event.articleId}`});
      // const open = () => {
      //   this.selectedEvent = event
      //   this.selectedElement = nativeEvent.target
      //   setTimeout(() => {
      //     this.selectedOpen = true
      //   }, 10)
      // }
      //
      // if (this.selectedOpen) {
      //   this.selectedOpen = false
      //   setTimeout(open, 10)
      // } else {
      //   open()
      // }
      //
      // nativeEvent.stopPropagation()
    },
    updateForm(item) {
      this.selectArticle = _.cloneDeep(item);
      this.$router.push({path:`/board/${item.boardId}/article/form/${item.articleId}`});
    },
    deleteArticle(item) {
      if(confirm('삭제하시겠습니까?')) {
        articleApi.delete(item.boardId, item.articleId).then(() => {
          this.search(this.param);
        });
      }
    }
  },
  created: function () {
    roleApi.list(true).then(data => {
      this.boardRoleItems = data;
    });
    boardApi.get(this.$route.params.id).then(data => {
      this.board = data;
      this.categoryItems = (data.boardCategories??[]).length > 0 ? data.boardCategories : null;
    });

    const storedParams = this.$store.getters?.params??{};
    if(storedParams.name !== this.$options.name)
      this.$store.commit('setParams', Object.assign(this.param, {name:this.$options.name}))
    else {
      this.options = storedParams
      this.param = storedParams
    }

    // console.log(this.$store.state.currentMenu)
    // console.log(this.$store.getters.menu)
    // console.log(this.$store.getters.params)

  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.7%;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          span {
            margin-left: 8px;
          }

          &:nth-child(2) {
            padding-left: 5px;
            padding-bottom: 3px;
          }

          .monthBx {
            display: flex;
            align-items: center;
            height: 35px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }

              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
      .txtPoint {
        color: $point-color;
      }
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        //margin-right: 15px;
      }
    }
  }
}
</style>
